/* eslint-disable import/prefer-default-export */
import { differenceInDays, format } from 'date-fns';

const getStateGroup = (SOR, State) => {
  if (SOR === 'International') return 'International';
  if (State === 'FL') return 'Domestic FL';
  return 'Domestic Non-FL';
};

const datasetParams = {
  mainFile: 'DCO_Bookings/Outputs/DCO_Bookings_reducedData.csv',
  runDetailsFile: 'DCO_Bookings/Outputs/DCO_Bookings_runDetails.csv',
  tableName: 'DCO_bookings',
  mainDateField: 'Date',
  headersRemaps: {
    BookDate: 'Date',
    EventStartDate: 'EventDate',
    Channel_Remapped: 'Channel',
    SOR: 'SOR',
    State: 'State',
    Item_Type: 'ItemType',
  },
  valuesRemaps: {
    Reseller: {
      'ENTERTAINMENT BENEFITS GRP-EZ TIX': 'EBG',
    },
  },
  calculatedMetrics: {
    SalesPerCap: {
      numerator: 'SalesRevenues',
      denominator: 'SalesUnits',
    },
    BookingsPerCap: {
      numerator: 'BookingsRevenues',
      denominator: 'BookingsUnits',
    },
  },
  metrics: {
    SalesUnits: {
      fieldName: 'SalesUnits',
      displayName: 'Sales Units',
      chartFormat: ',',
      format: {
        style: 'decimal',
        // maximumFractionDigits: 0,
      },
    },
    SalesPerCap: {
      fieldName: 'SalesPerCap',
      displayName: 'Sales Per Cap',
      chartFormat: '$.2f',
      format: {
        style: 'currency',
        currency: 'USD',
        // maximumFractionDigits: 2,
      },
    },
    SalesRevenues: {
      fieldName: 'SalesRevenues',
      displayName: 'Sales Revenues',
      chartFormat: '$~s',
      format: {
        style: 'currency',
        currency: 'USD',
        // maximumFractionDigits: 0,
      },
    },
    BookingsUnits: {
      fieldName: 'BookingsUnits',
      displayName: 'Bookings Units',
      chartFormat: ',',
      format: {
        style: 'decimal',
        // maximumFractionDigits: 0,
      },
    },
    BookingsPerCap: {
      fieldName: 'BookingsPerCap',
      displayName: 'Bookings Per Cap',
      chartFormat: '$.2f',
      format: {
        style: 'currency',
        currency: 'USD',
        // maximumFractionDigits: 2,
      },
    },
    BookingsRevenues: {
      fieldName: 'BookingsRevenues',
      displayName: 'Bookings Revenues',
      chartFormat: '$~s',
      format: {
        style: 'currency',
        currency: 'USD',
        // maximumFractionDigits: 0,
      },
    },
    Cancellations: {
      fieldName: 'Cancellations',
      displayName: 'Cancellations',
      chartFormat: ',',
      format: {
        style: 'decimal',
        // maximumFractionDigits: 0,
      },
    },
  },
  transformRow: (row) => ({
    ...row,
    StateGroup: getStateGroup(row.SOR, row.State),
    Date: format(new Date(row.Date), 'yyyy-MM-dd'),
    Year: format(new Date(row.Date), 'yyyy'),
    YearMonth: format(new Date(row.Date), 'yyyy-MM'),
    EventDate: format(new Date(row.EventDate), 'yyyy-MM-dd'),
    EventYear: format(new Date(row.EventDate), 'yyyy'),
    EventYearMonth: format(new Date(row.EventDate), 'yyyy-MM'),
    Reseller: row.Reseller.toString(),
    leadTime: differenceInDays(new Date(row.Date), new Date(row.EventDate)),
    // eslint-disable-next-line no-nested-ternary
    ProductFamily: row.ItemType?.split(' ')[0],
    Cancellations: row.SalesUnits - row.BookingsUnits,
  }),
  filterDimensions: {
    Date: {
      // order: 'desc',
      sortType: 'alpha',
    },
    Year: {
      // order: 'desc',// Gets overridden by the getFilterValues special case
      sortType: 'alpha',
    },
    YearMonth: {
      // order: 'desc',// Gets overridden by the getFilterValues special case
      sortType: 'alpha',
    },
    EventDate: {
      order: 'desc',
      sortType: 'alpha',
    },
    EventYear: {
      order: 'desc',
      sortType: 'alpha',
    },
    EventYearMonth: {
      order: 'desc',
      sortType: 'alpha',
    },
    Channel: {
      order: 'desc',
      customOrder: ['Direct', 'Domestic Reseller', 'International Reseller', 'Vacation Packages'],
    },
    SOR: {
      order: 'desc',
      customOrder: ['Local', 'Same Day', 'Drive & Overnight', 'Domestic', 'International'],
    },
    StateGroup: {
      order: 'desc',
      customOrder: ['Domestic FL', 'Domestic Non-FL', 'International'],
    },
    State: {
      order: 'desc',
    },
    Reseller: {
      order: 'asc',
      // sortType: 'alpha',
      customOrder: [
        'Attraction Tickets Direct-UK',
        'ATTRACTION WORLD - SELIGO',
        'EBG',
        'InsiderGuide com LC',
        'US RENT A CAR LTD-DCO',
        'GetYourGuide AG',
        'MILITARY - COMMANDER NAVAL BASE',
        'ATD TRAVEL SERVICES-WHITE LABEL',
        'Musement S.P.A.',
        'AIR FORCE CTRL / NAFI EZ TIX',
        'MILITARY - SHADES OF GREEN',
        'Suncoast USA Operadora',
        'VIP Jet Tours',
        'NAR Ltd',
        'Orlando Park Tickets',
        'Magic Stars Vacations',
        'ALL GUEST SERVICES',
        'HOTELBEDS',
        'Tripster',
        'Virazom - VMZ Viagens',
        'Blau International Corporation',
        'Travelrepublic LTD',
        'Hospitality Connect Florida',
        'WEBTRAVEL LLC dba SLA Tours',
        'CVC BRASIL OPERADORA E AGENCIA AR',
        'GALAXY VACATIONS-GROUPS',
        'Your Ticket Genie Ltd',
        'DIAMOND RESORTS INTERNATIONAL',
        'Kaluah Tours Operator',
        '',
      ],
    },
    ItemType: {
      order: 'desc',
      customOrder: ['Swim', 'Swim P.', 'Swim U.', 'Day', 'Day P.', 'Day U.', 'Other'],
    },
    ProductFamily: {
      order: 'desc',
      customOrder: ['Swim', 'Day', 'Other'],
    },
  },
};

export default datasetParams;
